module.exports = __webpack_public_path__ + "static/17.3_Renaissance-46b4dc238d9e0ae73e431d52895c418a.pdf";